import request from '@/utils/request'

export function getActList(id) {
  return request({
    url: '/product/participate/brand-goods/' + id,
    method: 'get',
  })
}
export function getBrandCate(id) {
  return request({
    url: '/product/brand/' + id,
    method: 'get',
  })
}
export function getPartGoods(params) {
  return request({
    url: '/product/participate/part-brand/goods/page',
    method: 'get',
    params,
  })
}
export function getBrandPlaceDetail(id) {
  return request({
    url: '/product/participate/part-brand/details/' + id,
    method: 'get',
  })
}
export function getCoupon(id) {
  return request({
    url: '/product/coupon/get-coupon/' + id,
    method: 'put',
  })
}

//获得一个tab品牌下的商品
export function getOneTabBrandGoods(params) {
  return request({
    url: '/product/participate/cate-goods/page',
    method: 'GET',
    params,
  })
}
